import { ChangeEvent, FormEvent, RefObject, ComponentProps } from 'react';
import { observer } from 'mobx-react-lite';
import styles from '@components/Search/components/ControlledSearchBox/ControlledSearchBox.styles';
import layoutUiState from '@features/layout/mobX/LayoutUiState';
import Icon from '@components/icons/Icon';
import Button from '@components/Button/Button';
import { useTranslation } from 'next-i18next';
import { handlePointerInputFocus, focusWithoutVisibleRing } from '@utils/focusWithoutVisibleRing';
export type PropsType = ComponentProps<'div'> & {
  inputRef: RefObject<HTMLInputElement | null>;
  onChange(event: ChangeEvent): void;
  onSubmit(): void;
  placeholder: string;
  value: string;
};
const ControlledSearchBox = ({
  inputRef,
  onChange,
  onSubmit,
  placeholder,
  value
}: PropsType) => {
  const {
    closeSearch
  } = layoutUiState;
  const {
    t
  } = useTranslation('common');
  const handleCloseSearch = () => {
    closeSearch();
  };
  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (onSubmit) {
      onSubmit();
    }
    if (inputRef.current) {
      focusWithoutVisibleRing(inputRef.current);
    }
  }
  function handleReset(event: FormEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (inputRef.current) {
      focusWithoutVisibleRing(inputRef.current);
    }
  }
  return <div sx={styles.searchBoxContainer} data-cy="SearchBox">
      <div sx={styles.searchBoxWrapper}>
        <Icon size={['29px', '29px', '29px', '29px', '36px']} icon="Search" aria-label={t('search')} title={t('search')} />
        <div sx={styles.fromContainer}>
          <form action="" noValidate onSubmit={handleSubmit} onReset={handleReset}>
            <input sx={styles.searchBox} type="search" autoComplete="off" autoCorrect="off" autoCapitalize="off" placeholder={placeholder} spellCheck={false} maxLength={512} ref={inputRef} value={value} onChange={onChange} onMouseDown={handlePointerInputFocus} id="search-input" />
          </form>
        </div>
        <Button variant="iconOnly" onClick={handleCloseSearch} cy="SearchModalCloseButton" title={t('close')} addSx={{
        zIndex: 9999
      }}>
          <Icon size={['16px', '16px', '21px', '21px', '26px']} icon="Close2" title={t('close')} />
        </Button>
      </div>
    </div>;
};
export default observer(ControlledSearchBox);